import { useEffect, useState } from 'react';
import { ChatTabsEnum } from '../../../types/Chat';
import ChatGroupConversation from './ChatGroupConversation';
import { useRegions } from '../../../context/regions-context';

interface ChatGroupConversationsListProps {
  activeTab: ChatTabsEnum;
  regionChatConversations: any;
  onSelectCurrentChat: any;
  currentOpenChat: any;
  countUnseenForRegion: any;
  allUsers: any;
}

const ChatRegionConversationsList = ({
  regionChatConversations,
  onSelectCurrentChat,
  currentOpenChat,
  countUnseenForRegion,
  allUsers,
}: ChatGroupConversationsListProps) => {
  const [regionName, setRegionName] = useState<any>('');
  const { activeRegion } = useRegions();

  useEffect(() => {
    if (!activeRegion) return;

    setRegionName(activeRegion?.name);
  }, [activeRegion]);

  return (
    <div className="space-y-1 mt-4">
      {regionChatConversations.map((chat: any, index: number) => {
        return (
          <div
            className=""
            key={index}
            onClick={() => onSelectCurrentChat(chat)}
          >
            <ChatGroupConversation
              chat={chat}
              allUsers={allUsers}
              groupName={regionName}
              countUnseenForRegion={countUnseenForRegion}
              currentOpenChat={currentOpenChat}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ChatRegionConversationsList;
